import { render, staticRenderFns } from "./ListWithdrawalPage.vue?vue&type=template&id=0afa6b9f&scoped=true"
import script from "./ListWithdrawalPage.vue?vue&type=script&lang=js"
export * from "./ListWithdrawalPage.vue?vue&type=script&lang=js"
import style0 from "./ListWithdrawalPage.vue?vue&type=style&index=0&id=0afa6b9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa6b9f",
  null
  
)

export default component.exports